import { MainTemplate } from "@/components/templates";
import { PageTitle } from "@/components/molecules";
import { UpdatePasswordForm } from "@/components/organisms";
import { useContext } from "react";
import { AuthContext } from "@/contexts/AuthContext";
import { FormProvider, useForm } from "react-hook-form";
import { useSnackBar } from "@moneyforward/mfx_biz_react_components";
import { getErrorMessage } from "@/libs/errors";
import useRollbarUtil from "../hooks/useRollbarUtil";

type FormValues = {
  password: string;
};

export const SetNewPasswordPage = () => {
  const { rollbar } = useRollbarUtil();
  const authContext = useContext(AuthContext);

  const methods = useForm<FormValues>({
    reValidateMode: "onBlur",
    defaultValues: {
      password: "",
    },
  });

  const { notify } = useSnackBar();

  const handleSubmit = async (formValues: FormValues) => {
    authContext
      .completeNewPassword(formValues.password)
      .then(async () => {
        notify("ログインが完了しました");
      })
      .catch((err) => {
        rollbar.error("Failed to set new password", err);
        notify(getErrorMessage(err, "パスワード設定に失敗しました"));
      });
  };

  return (
    <MainTemplate title={`パスワード変更`}>
      <PageTitle
        mainTitle={`パスワード変更`}
        subTitle={
          <>
            パスワードの変更が必要です
            <br />
            新しいパスワードを設定してください
          </>
        }
      />
      <FormProvider {...methods}>
        <UpdatePasswordForm onSubmit={handleSubmit} />
      </FormProvider>
    </MainTemplate>
  );
};
